import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add, load } from '../../../reducers/equipmentCategory/equipmentCategory.actions';
import { equipmentCategories, loading } from '../../../reducers/equipmentCategory/equipmentCategory.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminEquipmentCategories.css';
import ConnectedEquipmentCategoryForm from './EquipmentCategoryForm/EquipmentCategoryForm';

export class AdminEquipmentCategories extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areEquipmentCategoriesLoading} />
        <Row  style={{ 'margin-bottom': '15px' }}><Col><Button onClick={this.props.addEquipmentCategories} bsStyle="primary">Add New Equipment Category</Button></Col></Row>
        {this.props.equipmentCategories.map(equipmentCategory => (
          <Row key={equipmentCategory.id}>
            <Col>
              <ConnectedEquipmentCategoryForm equipmentCategory={equipmentCategory} />
            </Col>
          </Row>
          ))}
        <Row><Col><Button onClick={this.props.addEquipmentCategories} bsStyle="primary">Add New Equipment Category</Button></Col></Row>
      </span>
    );
  }
}

AdminEquipmentCategories.propTypes = {
  load: PropTypes.func.isRequired,
  addEquipmentCategories: PropTypes.func.isRequired,
  areEquipmentCategoriesLoading: PropTypes.bool.isRequired,
  equipmentCategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areEquipmentCategoriesLoading: loading(state),
  equipmentCategories: equipmentCategories(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  addEquipmentCategories: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminEquipmentCategories);



// WEBPACK FOOTER //
// ./src/components/Admin/EquipmentCategories/AdminEquipmentCategories.jsx